<template>
  <div class="helpContractEmail">
    <help-header />
    <v-divider class="helpContractEmail_divider" />
    <h5 class="helpContractEmail_notice">
      お問い合わせいただき、誠にありがとうございます。後ほど担当者からご連絡いたします。
    </h5>
    <section v-if="false" class="helpContractEmail-need_details">
      <section class="helpContractEmail-need_details-item">
        <span class="helpContractEmail-need_details-title"
          >お問い合わせ番号</span
        >
        <p class="helpContractEmail-need_details-text">{{ supportNumber }}</p>
      </section>
    </section>

    <section class="helpContractEmail-actions">
      <v-btn text class="helpContractEmail-return" @click="handleBack"
        >{{ currentCategory.title }}に戻る</v-btn
      >
    </section>
    <!-- Message dialog -->
    <clip-dialog-message
      :open="!!dialogMessageText"
      :message="dialogMessageText"
      @onClose="closeDialogMessage"
    />
    <!-- ----------------- -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import HelpHeader from '../HelpHeader.vue';
import ClipDialogMessage from '@/components/dialogs/ClipDialogMessage.vue';

export default {
  name: 'HelpContractEmail',
  components: {
    HelpHeader,
    ClipDialogMessage,
  },
  data() {
    return {
      dialogMessageText: '',
      isDisable: false,
      maxInput: 1000,
    };
  },
  computed: {
    ...mapState({
      helpCategories: (state) => state.help.categories,
      userInquiry: (state) => state.help.userInquiry,
    }),
    currentCategory() {
      return this.helpCategories.find(
        (item) => item.id === this.$route.params.id
      );
    },
    currentTopic() {
      return (
        (this.currentCategory.sub_topic || []).find(
          (item) => item.id === this.$route.params.topic
        ) || {}
      );
    },
    questions() {
      return this.currentTopic.list || [];
    },
    supportNumber() {
      return this.userInquiry.support_no;
    },
  },
  watch: {
    dialogMessageText(val) {
      val || this.closeDialogMessage();
    },
  },
  mounted() {
    if (this.$route.query.dl === 1) {
      this.displayDeleteMessage();
    }
  },
  methods: {
    ...mapActions('help', ['setQuestionInput']),
    handleBack() {
      this.navigateTo({
        name: 'help-cat',
        params: { id: this.$route.params.id },
      });
    },
    navigateTo(route) {
      this.routerPush(route);
    },
    displayDeleteMessage() {
      this.dialogMessageText = 'グループを削除しました。';
      this.$router.replace({ query: null });
    },
    closeDialogMessage() {
      this.dialogMessageText = null;
    },
  },
};
</script>

<style lang="scss">
.helpContractEmail {
  &_divider {
    margin-top: 15px;
    &.theme--light.v-divider {
      border-color: #ccc;
    }
  }
  &_notice {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #666;
    margin-top: 15px;
  }
  &-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
  }
  &-need {
    margin-top: 32px;
    margin-bottom: 10px;
    font-size: 14px;
    text-align: left;
    color: #666;
    &_input {
      &-bottom {
        &_message,
        &_counter {
          font-size: 12px;
          text-align: left;
          color: #989898;
        }
        &_counter {
          em {
            &.error {
              color: #eb545b;
              background-color: unset !important;
            }
            &.not-exceed {
              color: #0075c2;
              background-color: unset !important;
            }
          }
        }
      }
    }
    &_details {
      margin-top: 15px;
      padding: 15px 0;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      &-item {
        display: flex;
      }
      &-title {
        width: 150px;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
      }
      &-text {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: normal;
        text-align: left;
        color: #666;
        word-wrap: break-word;
        margin-bottom: 0 !important;
      }
    }
  }
  &-return {
    &.v-btn:not(.v-btn--round).v-size--default {
      padding: 0;
    }
  }
}
</style>
